import { forwardRef, type HTMLAttributes, type ReactElement } from 'react';
import { cn } from '@/lib/utils';

interface SidebarProps extends HTMLAttributes<HTMLDivElement> {
  collapsed?: boolean;
}

/**
 * Sidebar - Main container for sidebar navigation
 *
 * Provides a fixed left sidebar with consistent styling and layout.
 */
export const Sidebar = forwardRef<HTMLDivElement, SidebarProps>(
  ({ className, children, collapsed, ...props }, ref): ReactElement => (
    <div
      ref={ref}
      className={cn(
        'fixed left-0 top-0 z-40 h-dvh transition-all border-r bg-background flex flex-col',
        collapsed ? 'w-20' : 'w-64',
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
);
Sidebar.displayName = 'Sidebar';
